import React from 'react';
import { Stack, Typography } from '@mui/material';

const BodyPart = ({ item, setBodyPart, bodyPart }) => {
  const images = {
    all: require('../assets/icons/cardio.png'), // Added for 'all' muscle group
    Stretching: require('../assets/icons/equipment.png'),
    lower_back: require('../assets/icons/back.png'),
    Legs: require('../assets/icons/lower_legs.png'),
    Neck: require('../assets/icons/neck.png'),
    Legs_and_Glutes: require('../assets/icons/upper_legs.png'),
    Abdominal: require('../assets/icons/waist.png'),
    Arms: require('../assets/icons/lower_arms.png'),
    Triceps_brachii: require('../assets/icons/upper_arms.png'),
    Full_Body: require('../assets/icons/cardio.png'),
    Upper_body: require('../assets/icons/chest.png'),
    Back: require('../assets/icons/back.png'),
    Αnkle: require('../assets/icons/lower_legs.png'),
    Core: require('../assets/icons/waist.png'),
    Chest: require('../assets/icons/chest.png'),
    Shoulders: require('../assets/icons/shoulders.png'),
  };

  return (
    <Stack
      type="button"
      alignItems="center"
      justifyContent="center"
      className="bodyPart-card"
      sx={{
        borderTop: bodyPart === item ? '4px solid #B5A78A' : 'none',
        background: bodyPart === item ? '#fff' : '#fff',
        borderRadius: '50%',
        width: '120px',
        height: '120px',
        cursor: 'pointer',
        gap: '15px',
        transform: bodyPart === item ? 'scale(1.1)' : 'scale(1)',
        transition: 'transform 0.3s ease, background 0.3s ease, box-shadow 0.3s ease',
        boxShadow: bodyPart === item
          ? '0px 8px 16px rgba(0, 0, 0, 0.2)'
          : '0px 4px 8px rgba(0, 0, 0, 0.1)',
        padding: '10px',
      }}
      onClick={() => {
        setBodyPart(item);
        window.scrollTo({ top: 1800, left: 100, behavior: 'smooth' });
      }}
    >
      <img
        src={images[item.replace(/ /g, '_')]}
        alt={item.replace(/ /g, '_')}
        style={{ width: '50px', height: '50px', objectFit: 'contain' }}
      />
      <Typography
        fontSize="13px"
        fontWeight="bold"
        fontFamily="Alegreya"
        color="#3A1212"
        textTransform="capitalize"
        sx={{ textAlign: 'center', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
      >
        {item}
      </Typography>
    </Stack>
  );
};

export default BodyPart;